import { defineDirective, FieldViewModel, IOmniaShell, labels, shell } from "../../omnia"
import { IAnalysisEditCommand, ISoilService } from "../../types"
import { SoilMapContext } from "../map/context"
import { IDashboardContext } from "../types"
import { NitrogenAnalysisVM } from "./nitrogen-vm"

export class NitrogenAnalysisTableCtrl {

    static create(): ng.IDirective {
        return defineDirective(NitrogenAnalysisTableCtrl, "app/soil/dashboard/nitrogen/nitrogen.html", {
            context: "="
        });
    }

    public readonly readOnly = this.shell.isReadOnly(p => p.soil)

    private context: IDashboardContext;

    public map: SoilMapContext;
    public selectedField: FieldViewModel;
    public selectedCropping: FieldViewModel;

    private nitrogenAnalysis: NitrogenAnalysisVM[];

    private showNAnalysisHistory: boolean;


    static $inject = ["$scope", "OmniaSoilService", "OmniaShell"];

    constructor($scope: ng.IScope, private svc: ISoilService, private shell: IOmniaShell) {

        $scope.$watch("vm.context", () => this.setup());

    }


    private setup() {

        this.map = null
        this.selectedField = null
        this.selectedCropping = null
        this.nitrogenAnalysis = null

        if (!this.context) return;

        this.map = this.context.map;
        this.selectedField = this.context.selectedField;
        this.selectedCropping = this.context.selectedCropping;

        if (this.selectedField) {

            let currentViewKey = this.map.group ? this.map.group.key : null;

            this.nitrogenAnalysis = NitrogenAnalysisVM.create(this.svc, this.selectedField, this.selectedCropping, currentViewKey == "N");

        }

    }

    private hasHistory(): boolean {
        return !!this.nitrogenAnalysis.filter(a => !a.current).length;
    }

    private hasCurrent(): boolean {
        return !!this.nitrogenAnalysis.filter(a => a.current).length;
    }

    private createNitrogenAnalysis() {

        this.editNitrogenAnalysis(null);

    }

    private editNitrogenAnalysis(vm: NitrogenAnalysisVM) {

        let cmd: IAnalysisEditCommand = {
            analysis: vm ? vm.analysis : null,
            edit: true,
            context: null,
            alloc: this.selectedField
        };


        this.context.showDialog("omnia-soil-editor-nitrogen-popup", cmd);

    }

    getNitrogenAnalysisTypeName(analysis: NitrogenAnalysisVM) {

        const at = analysis.analysis.AnalysisType

        return at
            ? labels.NitrogenAnalysisType(at)
            : null

    }

    private selectNitrogenAnalysis(a: NitrogenAnalysisVM) {
        this.map.selectView("N");
        let zone = this.map.getCroppingZoneFromCurrentView(a.cropping.croppingId);
        this.context.setSelectedField(a.cropping, zone, true);
    }

    unAllocNitrogenAnalysis(vm: NitrogenAnalysisVM) {

        var msg = "You are about to unallocate this nitrogen analysis from the cropping " + vm.cropping.description + ". Are you sure ?";

        shell.showDeleteCancel(this.shell, msg, "Unallocate").then(r => {
            if (r) {
                this.svc.unallocNitrogenAnalysis(vm.analysis.NitrogenAnalysisId, vm.cropping.croppingId)
                    .then(r => this.context.refresh());
            }
        });

    }

    getValueIndex(vm: NitrogenAnalysisVM, value: number) {
        return vm.getAnalysisIndex('N', value);
    }

}
